export default "__VITE_ASSET__0ad372be__"